export default {
    apiCallsInProgress: 0,
    tokenRenewalComplete: true,
    login: {
        nome: null,
        permissoes: null,
        token: null,
        psr: null,
        role: null,
        mensagem: null
    },
    alert: {
        titulo: null,
        conteudo: null,
        botoes: null,
        customClose: null
    },
    configuracao: null,
    menu: {
        largura: 240,
        open: true
    },
    novoFiltro: {
        largura: 480,
        open: false,
        changeColor: false,
        selectNumeroBa: undefined,
        selectOsbd: undefined,
        selectMatriculaTecnico: undefined,
        selectPeriodoAnterior: undefined,
        rotaDetalhar: undefined,
    },
    migalha: []
};
